import React from "react";
import gbsLogo from "./assets/gbs_logo_trimmed.png";
import heroImg from "./assets/gbs_hero.jpg";
import programJayanti from "./assets/gbs_program_jayanti.jpg";

// Naya program add karne ke liye yahan ek object add karo
const programs = [
  { title: "Dr. Babasaheb Ambedkar Ji Jayanti", date: "14 April 2025", image: programJayanti },
];

export default function Landing({ onSignIn, onRegister }) {
  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg, #0D1B3E, #1A2F5A)", color: "#fff", fontFamily: "sans-serif" }}>
      <style>{`
        .gbs-name-short { display: none; }
        @media (max-width: 480px) {
          .gbs-name-full { display: none; }
          .gbs-name-short { display: inline; }
        }
      `}</style>
      {/* TOP BAR */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px", flexWrap: "wrap", gap: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 48, height: 48, boxSizing: "border-box", padding: 3, background: "#fff", borderRadius: "50%", flexShrink: 0 }}>
            <img src={gbsLogo} alt="GBS Logo" style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }} />
          </div>
          <h2 style={{ margin: 0 }}>
            <span className="gbs-name-full">Global Bahuudeshiya Sanstha</span>
            <span className="gbs-name-short">GBS</span>
          </h2>
        </div>
        <div style={{ display: "flex", gap: 12 }}>
          <button onClick={onSignIn} style={{ padding: "8px 18px", borderRadius: 8, border: "1px solid #fff", background: "transparent", color: "#fff", cursor: "pointer" }}>
            Sign In
          </button>
          <button onClick={onRegister} style={{ padding: "8px 18px", borderRadius: 8, border: "none", background: "#fff", color: "#0D1B3E", fontWeight: 600, cursor: "pointer" }}>
            Register
          </button>
        </div>
      </div>

      {/* HERO SECTION */}
      <div style={{ textAlign: "center", padding: "24px 20px 60px" }}>
        <img
          src={heroImg}
          alt="GBS program — Bhagwan Buddha aur Dr. Babasaheb Ambedkar Ji ko abhivadan"
          style={{ width: "100%", maxWidth: 560, aspectRatio: "3 / 2", objectFit: "cover", display: "block", margin: "0 auto 24px", borderRadius: 16, boxShadow: "0 8px 24px rgba(0,0,0,0.35)" }}
        />
        <h1 style={{ fontSize: 36, marginBottom: 12 }}>Seva aur Vikas</h1>
        <p style={{ fontSize: 16, color: "rgba(255,255,255,0.7)", maxWidth: 600, margin: "0 auto" }}>
          Sthapana 2013 — Global Bahuudeshiya Sanstha (GBS) ek NGO hai jo samaj seva
          aur vikas ke liye samarpit hai. Hamare saath judiye.
        </p>
        <button onClick={onRegister} style={{ marginTop: 24, padding: "12px 28px", borderRadius: 10, border: "none", background: "#fff", color: "#0D1B3E", fontWeight: 700, fontSize: 15, cursor: "pointer" }}>
          Member Baniye →
        </button>
      </div>

      {/* PROGRAMS SECTION */}
      <div style={{ padding: "40px 20px", textAlign: "center" }}>
        <h3 style={{ marginBottom: 24 }}>Hamare Programs</h3>
        <div style={{ display: "flex", gap: 20, justifyContent: "center", flexWrap: "wrap" }}>
          {programs.map((p) => (
            <div key={p.title} style={{ width: 280, maxWidth: "100%", background: "#fff", borderRadius: 16, overflow: "hidden", boxShadow: "0 4px 16px rgba(0,0,0,0.2)", textAlign: "left" }}>
              <img src={p.image} alt={p.title} loading="lazy" style={{ width: "100%", display: "block", aspectRatio: "800 / 955", objectFit: "cover" }} />
              <div style={{ padding: 16 }}>
                <div style={{ color: "#0D1B3E", fontWeight: 700, fontSize: 16, marginBottom: 4 }}>{p.title}</div>
                <div style={{ color: "#0D1B3E", opacity: 0.65, fontSize: 13 }}>{p.date}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
